import { render, staticRenderFns } from "./StrapiCollectionComponent.vue?vue&type=template&id=7398a819"
import script from "./StrapiCollectionComponent.vue?vue&type=script&lang=js"
export * from "./StrapiCollectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports